import React from "react";

import { IgAccordion } from "@intelligems/ig-theme";
import { ProgressBarWidgetVariant } from "@intelligems/ig-types";
import { textVariables } from "@intelligems/ig-widgets";
import { Grid } from "@mui/material";
import { ShippingProgressBarIconsSection } from "@src/components/ColorAndStyle/sections/IconsSection";
import { BaseTextInput } from "@src/features/personalizations/components/offerModifications/userInterfaces/BaseTextInput";
import { useSelector } from "@src/store";
import { getVariationOffer } from "@src/store/slices/offers/selectors";

interface ShippingProgressBarSettingsProps {
  interfaceId?: string;
  variationId: string;
  widgetVariantType: ProgressBarWidgetVariant;
  underThresholdText: string | null;
  setUnderThresholdText: (value: any) => void;
  aboveThresholdText: string | null;
  setAboveThresholdText: (value: any) => void;
  breakpointText?: string | null;
  setBreakpointText?: (value: any) => void;
  showBreakpoint?: boolean;
  activeIconColor?: string;
  inactiveIconColor?: string;
  activeBackgroundColor?: string;
  inactiveBackgroundColor?: string;
}

export const ShippingProgressBarSettings = ({
  interfaceId,
  variationId,
  widgetVariantType,
  underThresholdText,
  setUnderThresholdText,
  aboveThresholdText,
  setAboveThresholdText,
  breakpointText,
  setBreakpointText,
  showBreakpoint,
  activeIconColor,
  inactiveIconColor,
  activeBackgroundColor,
  inactiveBackgroundColor,
}: ShippingProgressBarSettingsProps) => {
  const offer = useSelector(getVariationOffer(variationId));
  return (
    <Grid item container direction={"column"} rowSpacing={3}>
      <Grid item xs={12}>
        <BaseTextInput
          label={"Dynamic progress text (unlock prompt)"}
          value={underThresholdText}
          onChange={setUnderThresholdText}
          variables={textVariables.nextBreakpoint}
          limit={140}
          placeholder={
            offer?.unitType === "unit"
              ? "Buy {{Amount remaining}} to get {{Discount amount}}!"
              : "Spend {{Amount remaining}} to get {{Discount amount}}"
          }
        />
      </Grid>
      <Grid item xs={12}>
        <BaseTextInput
          label={"Dynamic progress text (reward text)"}
          value={aboveThresholdText}
          onChange={setAboveThresholdText}
          variables={textVariables.currentBreakpoint}
          limit={140}
          placeholder={"You've earned free shipping"}
        />
      </Grid>
      {interfaceId && showBreakpoint && widgetVariantType !== "progressBar3" ? (
        <>
          <Grid item xs={12}>
            <BaseTextInput
              label={"Breakpoint text"}
              value={breakpointText}
              onChange={setBreakpointText!}
              variables={textVariables.currentBreakpoint}
              limit={140}
              placeholder={"Free shipping"}
            />
          </Grid>
          <ShippingProgressBarIconsSection
            interfaceId={interfaceId}
            activeIconColor={activeIconColor}
            inactiveIconColor={inactiveIconColor}
            activeBackgroundColor={activeBackgroundColor}
            inactiveBackgroundColor={inactiveBackgroundColor}
          />
        </>
      ) : null}
    </Grid>
  );
};
